import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import GetInTouch from "./pages/GetInTouch";
import WHYCHOOSEUSLEARNMOREPAGE from "./pages/WHYCHOOSEUSLEARNMOREPAGE";
import Careers from "./pages/Careers";
import Services from "./pages/Services";
import HomePage from "./pages/HomePage";
import AboutUs from "./pages/AboutUs";


function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/why-choose-us-learn-more-page":
        title = "";
        metaDescription = "";
        break;
      case "/careers":
        title = "";
        metaDescription = "";
        break;
      case "/services":
        title = "";
        metaDescription = "";
        break;
      case "/home-page":
        title = "";
        metaDescription = "";
        break;
      case "/about-us":
        title = "";
        metaDescription = "";
        break;
      case "/get-in-touch":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/why-choose-us-learn-more-page"
        element={<WHYCHOOSEUSLEARNMOREPAGE />}
      />
      <Route path="/careers" element={<Careers />} />
      <Route path="/services" element={<Services />} />
      <Route path="/home-page" element={<HomePage />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/get-in-touch" element={<GetInTouch />} />
    </Routes>
  );
}
export default App;
